import 'alpine-turbo-drive-adapter'
import "alpinejs";
import tippy from 'tippy.js';

require('inputmask');

window._ = require('lodash');
window.tippy = tippy;
window.Turbolinks = require("turbolinks")
